import { useMemo } from "react";
import { Table } from "@/components/common/table/Table";
import type {
    ColumnDef,
    tableProps,
} from "@/components/common/table/types.props";
import type { institution } from "../userFormModal/types.props";

type institutionTableProps = Omit<tableProps<institution>, "columns">;

const InstitutionTable: React.FC<institutionTableProps> = ({
    data,
    isLoading,
    actions,
}) => {
    const columns = useMemo<ColumnDef<institution>[]>(
        () => [
            {
                accessorKey: "name",
                header: "Nombre de la Institución",
                cell: (institution) => institution.name,
            },
        ],
        [],
    );

    return (
        <Table<institution>
            columns={columns}
            data={data}
            isLoading={isLoading}
            actions={actions}
        />
    );
};

export default InstitutionTable;
